import React from 'react';

const MyItems = () => {
    return (
        <div>
            <h2>Thuis is my items section </h2>
        </div>
    );
};

export default MyItems;